export default {"src":"/_next/static/media/generic-thumbnail-mp4.7949654f.svg","height":92,"width":66,"blurWidth":0,"blurHeight":0};